import React from 'react';
import "../../css/DarkThemeClassic.css";
import "../../css/Fondo.css";

const EventoPreview = ({ theme = "dtc", eventName, descripcion, eventDate, imagePreview }) => {

    const convertDate = (timestamp) => {
        const date = new Date(timestamp);
        const formatter = new Intl.DateTimeFormat('es-ES', {
            day: '2-digit',
            month: 'short',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
        });
        const parts = formatter.formatToParts(date);
        return `${parts.find((p) => p.type === 'day').value} ${parts.find((p) => p.type === 'month').value.toUpperCase()} ${parts.find((p) => p.type === 'hour').value}:${parts.find((p) => p.type === 'minute').value}`;
    };

    return (
        <div className={`my-3 ${theme}-evento-preview`} style={{ margin: '0 auto', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.3)' }}>
            <section id="eventos" className={`${theme}-blog_section ${theme}-layout_padding fondo-1 fondo-padding`} style={{ textAlign: "justify" }}>
                <div className={`${theme}-box-preview ${theme}-b1`}>
                    <div className={`${theme}-img-box`}>
                        {imagePreview && (
                            <img
                                src={imagePreview}
                                alt={eventName || ""}
                            />
                        )}
                    </div>
                    <div className={`${theme}-detail-box`} style={{color: "#FFFFFF"}}>
                        <div className={`${theme}-img_date`}>
                            <h6>
                                {eventDate ? convertDate(eventDate) : ''}<br />
                            </h6>
                        </div>
                        <h3>{eventName}</h3>
                        <p>{descripcion || ""}</p>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default EventoPreview;
